import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface IRestoreFilePlacementsParams {
  filePlacementIds: string[];
}

export async function restoreFilePlacements({
  filePlacementIds,
}: IRestoreFilePlacementsParams): Promise<IApiResponse<null>> {
  const response = await fetcher('drive-view/file-placement/restore/bulk', {
    method: 'POST',
    body: { filePlacementIds },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to restore placements',
      statusCode: response.status,
      data: null,
    };
  }

  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: null,
  };
}
